/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable no-unused-vars */


import React, { useEffect }  from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { RiShoppingCart2Fill } from "react-icons/ri";
import { MdOutlineRestaurantMenu } from "react-icons/md";
import { AiOutlineDashboard, AiOutlineShoppingCart } from "react-icons/ai";

import { get_customer_dashboard_index_data } from '../../store/reducers/customerDashboardReducer';

import GetSellerConfig from '../GetSellerConfig';
import { currencyFormat } from '../CurrencyFormat';
import Moment from 'moment';

import config from '../../config';
const Index = () => {
    const sellerEnvironment = config.STR_ENVIRONMENT

    const { userInfo } = useSelector(state => state.auth)
    const { recentOrders, totalOrder, pendingOrder, cancelledOrder } = useSelector(state => state.customerDashboard)

    //const { seller } = useSelector(state => state.seller)
    
    // let stripePublishableKey = '' //seller.stripeTestPublishableKey
    // if (sellerEnvironment === 'Prod') {
    //     stripePublishableKey = seller?.stripeLivePublishableKey  
    // } else if (sellerEnvironment === 'Dev') {
    //     stripePublishableKey = seller?.stripeTestPublishableKey
    // }

    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerBoolShowSitePayments
    } = GetSellerConfig();

    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(get_customer_dashboard_index_data(userInfo.id))
    },[])

    // const redirectPayment = (ord) => {
    //     let items = 0;
    //     //console.log(ord.products.length)
    //     for (let i = 0; i < ord.products.length; i++) {
    //         items = ord.products[i].quantity + items; 
    //     }
    //     navigate('/payment', {
    //         state: {
    //             price: ord.price,
    //             items,
    //             orderId: ord._id, 
    //             isDeposit: ord.isDeposit,
    //             stripePublishableKey: stripePublishableKey,
    //             sellerPrimaryColor1: sellerPrimaryColor1,
    //             sellerSecondaryColor1: sellerSecondaryColor1 
    //         }
    //     }) 
    // }

    // navigate('/payment',{
    //         state: {
    //             price: price, 
    //             products: products,
    //             eventDetailsInfo : state,
    //             isDeposit: isDeposit 
    //         }
    //     })    

    // dispatch(place_order({
    //             customerName: userInfo.name, customerEmail:userInfo.email, customerPhone: userInfo.phoneNumber,
    //             price, products, shipping_fee, items, eventDetailsInfo : state, userId: userInfo.id, navigate, 
    //             isDeposit, stripePublishableKey, sellerPrimaryColor1, sellerSecondaryColor1, sellerBoolShowSitePayments 
    //         }))

    return (
        <div className='bg-white rounded-2xl'>
            <div className='border p-4 rounded-2xl'
                style={{
                    backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight, 
                    color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                    borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                }}>
                <div className='justify-start items-start flex text-2xl font-bold gap-1 mb-2'
                    style={{color:sellerPrimaryColor1 + sellerColorSuffixDark}}>
                    <AiOutlineDashboard size={30} className='' /> My Dashboard
                </div>
            
                <div className='grid grid-cols-3 md:grid-cols-1 gap-5'>
                    {/*justify-center items-center*/}
                    <div className='flex justify-left items-left pl-8 p-3 border rounded-md gap-5'
                        style={{
                            color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                        }}>
                        <div className='w-[90px] h-[60px] border-2 rounded-full flex justify-center items-center text-xl'
                            style={{
                                borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                            }}>
                            <span className='text-[32px]'>
                                <MdOutlineRestaurantMenu style={{color:sellerPrimaryColor1 + sellerColorSuffixMedium}} />
                            </span>
                            <span className='text-[32px]'>
                                <RiShoppingCart2Fill style={{color:sellerPrimaryColor1 + sellerColorSuffixMedium}} />
                            </span>
                        </div>
                        <div className='flex flex-col justify-start items-start'>
                            <h2 className='text-3xl font-bold'>{totalOrder}</h2>
                            <span>Orders</span>
                        </div>     
                    </div>
                    {/*justify-center items-center*/}
                    <div className='flex justify-left items-left pl-8 p-3 border rounded-md gap-5'
                        style={{
                            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                        }}>
                        <div className='w-[90px] h-[60px] border-2 rounded-full flex justify-center items-center text-xl'
                            style={{
                                borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                            }}>
                            <span className='text-[32px]'>
                                <MdOutlineRestaurantMenu style={{color:sellerPrimaryColor1 + sellerColorSuffixMedium}} />
                            </span>
                            <span className='text-[32px]'>
                                <RiShoppingCart2Fill style={{color:sellerPrimaryColor1 + sellerColorSuffixMedium}} />
                            </span>
                        </div>
                        <div className='flex flex-col justify-start items-start'>
                            <h2 className='text-3xl font-bold'>{pendingOrder}</h2>
                            <span>Pending Orders</span>
                        </div>     
                    </div>
                    {/*justify-center items-center*/}
                    <div className='flex justify-left items-left pl-8 p-3 border rounded-md gap-5'
                        style={{
                            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                        }}>
                        <div className='w-[90px] h-[60px] border-2 rounded-full flex justify-center items-center text-xl'
                            style={{
                                borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                            }}>
                            <span className='text-[32px]'>
                                <MdOutlineRestaurantMenu style={{color:sellerPrimaryColor1 + sellerColorSuffixMedium}} />
                            </span>
                            <span className='text-[32px]'>
                                <RiShoppingCart2Fill style={{color:sellerPrimaryColor1 + sellerColorSuffixMedium}} />
                            </span>
                        </div>
                        <div className='flex flex-col justify-start items-start'>
                            <h2 className='text-3xl font-bold'>{cancelledOrder}</h2>
                            <span>Cancelled Orders</span>
                        </div>     
                    </div>
                </div>
                <div className='bg-white'>
                <div className='border p-3 mt-2 rounded-md'
                    style={{
                        color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                        borderColor:sellerPrimaryColor1 + sellerColorSuffixDark,
                        backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight
                    }}>
                    <h2 className='text-xl font-bold'>Recent Orders</h2>
                    <div className='pt-2'>
                        <div className='relative overflow-x-auto rounded-md'>
                            <table className='w-full text-sm text-left' 
                                style={{color:sellerPrimaryColor1 + sellerColorSuffixDark}}>
                                <thead className='text-xs uppercase' 
                                    style={{
                                        color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                                        //backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight
                                    }}>
                                    <tr>
                                        <th scope='col' className='hidden px-3 py-1'>Order Id</th>
                                        <th scope='col' className='px-3 py-1'>Date/Time</th>
                                        <th scope='col' className='px-3 py-1'>Order Type</th>
                                        <th scope='col' className={`${sellerBoolShowSitePayments ? 'px-3 py-1' : 'hidden'}`}>
                                            Price/Status
                                        </th>
                                        <th scope='col' className='px-3 py-1'>Order Status</th>
                                        <th scope='col' className='px-3 py-1'>Action</th> 
                                    </tr>
                                </thead>
                                <tbody>
                                {  
                                    recentOrders.map((o,i) => 
                                        <tr key={i} className='border' 
                                            style={{
                                                backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight, 
                                                color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                                                borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                                            }}>
                                            <td scope='row' className='hidden px-3 py-2 font-medium whitespace-nowrap'>#{o._id}</td>
                                            <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>
                                                <Link to={`/customerDashboard/order/details/${o._id}`}>   
                                                    {Moment(o.date).format('MM/DD/yyyy h:mm A')}
                                                </Link>
                                            </td> 
                                            <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>
                                                <Link to={`/customerDashboard/order/details/${o._id}`}>
                                                    {o.orderType}
                                                </Link>
                                            </td>
                                            <td scope='row' className={`${sellerBoolShowSitePayments ? 'px-3 py-2 font-medium whitespace-nowrap' : 'hidden'}`}>
                                                <Link to={`/customerDashboard/order/details/${o._id}`}>
                                                    {currencyFormat.format(o.price)}/{o.payment_status }
                                                </Link>
                                            </td>
                                            <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>
                                                <Link to={`/customerDashboard/order/details/${o._id}`}>
                                                    {o.delivery_status}
                                                </Link>
                                            </td>
                                            <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>
                                                <Link to={`/customerDashboard/order/details/${o._id}`}>
                                                    <span className='bg-green-200 text-green-800 text-md font-semibold mr-2 px-3 py-[2px] rounded'>
                                                        View
                                                    </span>
                                                </Link>
                                                {
                                                    // o.payment_status !== 'paid' && sellerBoolShowSitePayments &&
                                                    //     <span onClick={() => redirectPayment(o)} 
                                                    //     className='hidden bg-green-200 text-green-800 text-md font-semibold mr-2 px-3 py-[2px] rounded cursor-pointer'>
                                                    //         Pay Now
                                                    //     </span> 
                                                }
                                            </td> 
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};

export default Index;





